module.exports = __webpack_public_path__ + "img/HC1037-112.9e4a3bb7.jpg";